import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { Typography } from 'shared/ui/Typography'
import { allowedRcsExtensionsFiltered } from '../../types/RcsValidFilesTypes'

type IOpenRcsNotSupportedFilesModalProps = {
  onClose?: () => void
  onContinue?: () => void
}

export const openRcsNotSupportedFilesModal = ({
  onClose,
  onContinue,
}: IOpenRcsNotSupportedFilesModalProps) => {
  const id = nanoid()
  modalStore.addModal({
    id,
    type: ModalTypeList.WARNING,
    title: 'Unsupported attachments in RCS',
    desc: (
      <>
        Some of your attachments aren’t supported in RCS. Supported formats:{' '}
        <Typography
          ariaLabel='RcsSupportedFormats'
          variant='body-rg-medium'
          color='var(--content-primary-secondary)'
        >
          {allowedRcsExtensionsFiltered.join(', ')}
        </Typography>
        . Unsupported files will be removed if you continue.
      </>
    ),
    primaryAction: {
      text: 'Continue',
      onAction: () => {
        modalStore.closeModal(id)
        onContinue && onContinue()
      },
    },
    secondaryAction: {
      text: 'Cancel',
      onAction: () => {
        modalStore.closeModal(id)
        onClose && onClose()
      },
    },
  })
}
